export const cacheBy = <T>(arr: T[], byKey: keyof T): Record<string, T | undefined> => {
  return arr.reduce<Record<string, T>>((acc, item) => {
    acc[String(item[byKey])] = item;
    return acc;
  }, {});
};
